import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ApiService } from '../api.service';

import { Response } from 'src/app/shared/models/api';
import { API_ENDPOINTS } from 'src/app/shared/utils/api-endpoints';
import { HANDLED_ERRORS } from 'src/app/shared/utils/http-context';

import { BehaviorSubject, Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class NotificationsService extends ApiService {
  private endpoint = API_ENDPOINTS.RR;
  private notificationOpen$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private notificationListData$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  private activeTab$: BehaviorSubject<'all' | 'unread' | 'approval'> = new BehaviorSubject<'all' | 'unread' | 'approval'>('unread');
  get notificationList() {
    return this.notificationListData$.value;
  }

  get sideBarState() {
    return this.notificationOpen$.value;
  }

  get activeTabValue() {
    return this.activeTab$.value;
  }


  getSideBarState() {
    return this.notificationOpen$.asObservable();
  }

  getActiveTabValue() {
    return this.activeTab$.asObservable();
  }

  getNotificationList() {
    return this.notificationListData$.asObservable();
  }

  setSideBarState(state: boolean): void {
    this.notificationOpen$.next(state);
  }

  setActiveTabValue(name : 'all' | 'unread' | 'approval' ): void {
    this.activeTab$.next(name);
  }

  setNotificationListData(data: any): void {
    this.notificationListData$.next(data);
  }

  fetchNotificationsList(formData: any): Observable<Response<any>> {
     const context = new HttpContext().set(HANDLED_ERRORS, [404, 422]);

    return this.get<Response<any>>({
      metadata: {
        ...this.getHttpParams(formData),
        context,
      },
      operation: 'DownloadReport',
      url: this.endpoint.getNotificationList(),
      // metadata: {
      //   context,
      // },
    });
  }

  fetchNotificationCount(): Observable<Response<any>> {
    return this.get<Response<any>> ({
      operation: 'fetchUnreadNotificationCount',
      url: this.endpoint.getNotificationCount()
    })
  }

  updateNotificationStatus(id: any): Observable<Response<any>> {
    return this.put<Response<any>> ({
      operation: 'fetchUnreadNotificationCount',
      url: this.endpoint.updateNotificationStatus(id)
    })
  }
}
